module.exports = __webpack_public_path__ + "img/download_header.e54509cc.png";